"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
const styled_components_1 = require("styled-components");
// sections
const Action_1 = require("../components/sections/Action");
const Consensus_1 = require("../components/sections/Consensus");
const Footer_1 = require("../components/sections/Footer");
const Hero_1 = require("../components/sections/Hero");
const Network_1 = require("../components/sections/Network");
const Orderbook_1 = require("../components/sections/Orderbook");
// styled
const Body_1 = require("../components/styled/Body");
const Fonts_1 = require("../components/styled/Fonts");
// https://www.styled-components.com/docs/api#injectglobal
// Use only for @font-face definition and body styling.
// tslint:disable-next-line
styled_components_1.injectGlobal `
  ${Body_1.Body}
  ${Fonts_1.Fonts}
`;
exports.HomePageTemplate = ({ pageTitle, heroTitle, heroContent, networkTitle, networkContent, orderbookTitle, orderbookContent, orderbookCtaLink, orderbookCtaText, consensusTitle, consensusContent, consensusCtaLink, consensusCtaText, actionTitle, actionContent }) => {
    return (React.createElement("div", null,
        React.createElement(react_helmet_1.default, { title: pageTitle }),
        React.createElement(Hero_1.Hero, { title: heroTitle, content: heroContent }),
        React.createElement("a", { id: "1" }),
        React.createElement(Network_1.Network, { title: networkTitle, content: networkContent }),
        React.createElement("a", { id: "2" }),
        React.createElement(Orderbook_1.Orderbook, { title: orderbookTitle, content: orderbookContent, ctaLink: orderbookCtaLink, ctaText: orderbookCtaText }),
        React.createElement("a", { id: "3" }),
        React.createElement(Consensus_1.Consensus, { title: consensusTitle, content: consensusContent, ctaLink: consensusCtaLink, ctaText: consensusCtaText }),
        React.createElement("a", { id: "4" }),
        React.createElement(Action_1.Action, { title: actionTitle, content: actionContent }),
        React.createElement(Footer_1.Footer, null)));
};
const HomePage = ({ data }) => {
    const { markdownRemark: post } = data;
    return (React.createElement(exports.HomePageTemplate, { pageTitle: post.frontmatter.pageTitle, heroTitle: post.frontmatter.heroTitle, heroContent: post.frontmatter.heroContent, networkTitle: post.frontmatter.networkTitle, networkContent: post.frontmatter.networkContent, orderbookTitle: post.frontmatter.orderbookTitle, orderbookContent: post.frontmatter.orderbookContent, orderbookCtaLink: post.frontmatter.orderbookCtaLink, orderbookCtaText: post.frontmatter.orderbookCtaText, consensusTitle: post.frontmatter.consensusTitle, consensusContent: post.frontmatter.consensusContent, consensusCtaLink: post.frontmatter.consensusCtaLink, consensusCtaText: post.frontmatter.consensusCtaText, actionTitle: post.frontmatter.actionTitle, actionContent: post.frontmatter.actionContent }));
};
exports.default = HomePage;
exports.homePageQuery = graphql `
  query HomePage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        pageTitle
        heroTitle
        heroContent
        networkTitle
        networkContent
        orderbookTitle
        orderbookContent
        orderbookCtaLink
        orderbookCtaText
        consensusTitle
        consensusContent
        consensusCtaLink
        consensusCtaText
        actionTitle
        actionContent
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/home-page.tsx